<template>
<v-container fluid fill-height class="pa-0">
    <v-layout v-if="errorMessage">
        <v-flex>
            <v-alert 
                :value="true" 
                outline 
                type="error">
                <span>{{ errorMessage }}</span>
            </v-alert>
        </v-flex>
    </v-layout>
    <loading v-if="loading"></loading>
    <v-layout v-if="!loading && !errorMessage">
        <v-flex>
            <PlantConfigurationNotificationSubscribersTable :data="items" :types="notificationTypes" @edit="openEdit"></PlantConfigurationNotificationSubscribersTable>
        </v-flex>
    </v-layout>
    <PlantConfigurationNotificationSubscribersAddEdit
        v-if="showAddEditDialog"
        :plantID="plantID"
        :types="notificationTypes"
        :show="showAddEditDialog"
        :originalItem="editedItem"
        @close="onAddEditClose"
        >
    </PlantConfigurationNotificationSubscribersAddEdit>
</v-container>
</template>

<script>
import BaseAPI from "@/api/baseApi";
import plantConfigurationApi from '@/api/plantConfigurationApi'
import Loading from '@/components/generic/Loading.vue';
import PlantConfigurationNotificationSubscribersTable from '@/components/plants/configuration/PlantConfigurationNotificationSubscribersTable.vue'
import PlantConfigurationNotificationSubscribersAddEdit from '@/components/plants/configuration/PlantConfigurationNotificationSubscribersAddEdit.vue'

export default {
    props: {
        plantID: {
            required: true,
            type: Number
        }
    },
    components: {
        Loading,
        PlantConfigurationNotificationSubscribersTable,
        PlantConfigurationNotificationSubscribersAddEdit
    },
    data() {
        return {
            errorMessage: null,
            loading: false,
            showAddEditDialog: false,
            editedItem: null,
            items: [],
            notificationTypes: []
        };
    },
    methods: {
        async loadData() {
            try {
                this.loading = true;

                const [notificationTypes, subscribers] = await Promise.all([
                    plantConfigurationApi.getPlantNotificationTypes(),
                    plantConfigurationApi.getPlantNotificationSubscribers(this.plantID)
                ]);

                this.notificationTypes = notificationTypes;
                this.items = subscribers;
            }
            catch (err) {
                this.errorMessage = await BaseAPI.parseHttpRequestError(err);

                throw err;
            }
            finally {
                this.loading = false;
            }
        },
        async openEdit(item) {
            this.editedItem = item;
            this.showAddEditDialog = true;
        },
        async onAddEditClose(saved) {
            this.showAddEditDialog = false;            

            if (saved === true) {
                await this.loadData();
            }
        }
    },
    created() {
        this.loadData();
    }
}
</script>

<style>

</style>
